import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export const setDate = (value: null | string, night?: null | string): void => {
  const calendar = ElementPropertiesManager.getProperty<SearchCalendarType>(document.getElementById('checkInDate') as HTMLInputElement, 'calendar')

  if (!calendar) {
    return
  }

  if (value === null || night === null) {
    calendar.getDate() !== null && calendar.clearDates()
    return
  }

  if (calendar.getMode() === 'range') {
    const startDate = new Date(value)
    const endDate = new Date(startDate)
    endDate.setDate(startDate.getDate() + Number(night))

    calendar?.setDate([calendar?.dateToYMD(startDate), calendar?.dateToYMD(endDate)])

    return
  }

  calendar?.setDate(value)
}
